import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
  max-width: 800px;
  overflow: hidden;
  margin: auto;
  height: 80%;
`;

const CarouselInner = styled.div`
  display: flex;
  transition: transform 0.5s ease-in-out;
  transform: ${({ currentIndex }) => `translateX(-${currentIndex * 100}%)`};
`;

const CarouselItem = styled.div`
  min-width: 100%;
  height: 500px;
  background-size: cover;
  background-position: center;
`;

const Arrow = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 10px;
  color: white;
  font-size: 24px;
  ${({ direction }) => (direction === 'left' ? 'left: 10px' : 'right: 10px')};
`;

const images = [
  'images/stadium.jpg',
  'images/remo.jpg',
  'images/gate.jpg',
  'images/OOU.png',
  'images/babcock.png',
  'images/babcock3.png',
  'images/babcock4.jpeg',
  
  'images/remo2.jpeg',
  'images/babcock-high.jpg',
  'images/gateway-stad.jpg',
];

const Carousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const length = images.length;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % length);
    }, 3000);
    return () => clearInterval(interval);
  }, [length]);

  const goToPrevious = () => {
    setCurrentIndex(currentIndex === 0 ? length - 1 : currentIndex - 1);
  };

  const goToNext = () => {
    setCurrentIndex((currentIndex + 1) % length);
  };

  return (
    <CarouselContainer>
      <CarouselInner currentIndex={currentIndex}>
        {images.map((image, index) => (
          <CarouselItem key={index} style={{ backgroundImage: `url(${image})` }} />
        ))}
      </CarouselInner>
      <Arrow direction="left" onClick={goToPrevious}>
        &#10094;
      </Arrow>
      <Arrow direction="right" onClick={goToNext}>
        &#10095;
      </Arrow>
    </CarouselContainer>
  );
};

export default Carousel;
